export enum ImportSteps {
  import = 0,
  mappingField = 1,
  tagsAndGroup = 2,
  info = 3,
}
